//src\components\utils\getVisiblePlatforms.js

import { PLATFORMS } from '../../constants/platforms';

/**
 * Возвращает массив платформ, доступных текущему пользователю.
 * isAdmin = true  → показываем всё
 * isAdmin = false → скрываем adminOnly-платформы
 */
export default function getVisiblePlatforms(isAdmin) {
  return PLATFORMS.filter(p => isAdmin || !p.adminOnly);
}
